import { SearchOutlined } from "@ant-design/icons"
import { Button, Input } from "antd"
import Title from "antd/es/typography/Title"
import React, { useState } from "react"
import { t } from "~/languages/i18n"
import CategoryList from "./CategoryList"
import FormAddCategory from "./FormAddCategory"

const List: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0)
  const [searchTerm, setSearchTerm] = useState("")
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}")

  const handleCategoryAdded = () => {
    setRefreshKey(prevKey => prevKey + 1)
  }

  const handleSearch = () => {
    setRefreshKey(prevKey => prevKey + 1)
  }

  return (
    <div className="px-4">
      <div style={{ justifySelf: "flex-start", justifyContent: "flex-start" }}>
        <Title level={2} className="mt-4">
          {t("Categories")}
        </Title>
      </div>

      <div className="flex flex-row w-full gap-6 mt-6">
        <FormAddCategory onCategoryAdded={handleCategoryAdded} />
        <div className={`flex flex-col  ${permissions.cateogry.create.enabled ? "w-1/2" : "w-full"}`}>
          <div className="flex justify-end">
            <Input
              className="w-[300px]"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              placeholder={t("Search for categories...")}
            />
            <Button className="ml-[15px]" type="primary" icon={<SearchOutlined />} onClick={handleSearch} />
          </div>
          <CategoryList key={refreshKey} searchTerm={searchTerm} />
        </div>
      </div>
    </div>
  )
}

export default List
